import { WelcomeCard } from "./WelcomeCard";
import { InfoSection } from "./InfoSection";
import {
  useAllCustomers,
  useAllGates,
  useAllLocations,
  useAllUnitDescription,
  useAllUnits,
  useSync,
  useAllInsurances,
} from "@api";
import { getWelcomeCardStats } from "./WelcomeCard/constants";
import { STRING } from "@constants";
import { LoaderOverlay } from "@components";
import { useSafeNavigation } from "@hooks";
import { UnitStatusByLocationCard } from "./UnitStatusByLocationCard";

export function Dashboard() {
  const { navigating } = useSafeNavigation();

  const { total: customersTotal, error: customersError } = useAllCustomers();
  const { total: unitsTotal, error: unitsError } = useAllUnits();
  const { total: unitDescriptionTotal, error: unitDescriptionError } =
    useAllUnitDescription();
  const { total: locationsTotal, error: locationsError } = useAllLocations();
  const { total: insurancesTotal, error: insurancesError } = useAllInsurances();
  const { total: gatesTotal, error: gatesError } = useAllGates();
  const { error: syncError } = useSync();

  const { data: locations } = useAllLocations();

  const stats = getWelcomeCardStats(
    customersTotal,
    unitsTotal,
    locationsTotal,
    insurancesTotal,
    gatesTotal,
    unitDescriptionTotal,
    {
      customers: !!customersError,
      units: !!unitsError,
      unitDescription: !!unitDescriptionError,
      locations: !!locationsError,
      insurances: !!insurancesError,
      gates: !!gatesError,
      sync: !!syncError,
    },
    true,
  );

  return (
    <div className="min-h-screen surface-ground p-4 md:p-2">
      <LoaderOverlay visible={navigating} />

      <section className="mb-6">
        <WelcomeCard
          title={STRING.DASHBOARD.WELCOME_TITLE}
          subtitle={STRING.DASHBOARD.WELCOME_SUBTITLE}
          statistics={stats}
        />
      </section>

      <section className="mb-6">
        <div className="flex align-items-center gap-3 mb-4">
          <i className="pi pi-map-marker text-2xl text-primary-500" />
          <h2 className="text-2xl font-semibold text-900 m-0">
            {STRING.DASHBOARD.UNIT_STATUS_BY_LOCATION}
          </h2>
        </div>

        <div className="grid">
          {locations?.map((location) => (
            <div key={location.id} className="col-12 md:col-6 xl:col-4">
              <UnitStatusByLocationCard
                locationId={location.id}
                locationName={location.locationName}
              />
            </div>
          ))}
        </div>
      </section>

      <section>
        <InfoSection />
      </section>
    </div>
  );
}
